import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    sendGlobalFeedback as sendGlobalFeedbackApi,
    sendBugReport as sendBugReportApi
} from 'src/api/apiCaller';
import { postFeedback as postFeedbackApi } from 'src/api/feedback';
import { PostFeedbackRequest } from 'src/types/feedback';

export const SLICE_NAME = 'feedback';

export const ACTION_TYPES = {
    CREATE_FEEDBACK: `${SLICE_NAME}/createFeedback`,
    SEND_GLOBAL_FEEDBACK: `${SLICE_NAME}/sendGlobalFeedback`,
    SEND_BUG_REPORT: `${SLICE_NAME}/sendBugReport`
};

export const postFeedback = createAsyncThunk(
    ACTION_TYPES.CREATE_FEEDBACK,
    async (
        { params }: { params: PostFeedbackRequest },
        { rejectWithValue }
    ) => {
        try {
            return await postFeedbackApi(params);
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const sendGlobalFeedback = createAsyncThunk(
    ACTION_TYPES.SEND_GLOBAL_FEEDBACK,
    async (
        {
            details,
            attachmentList
        }: { details: string; attachmentList: number[] },
        { rejectWithValue }
    ) => {
        try {
            return await sendGlobalFeedbackApi(details, attachmentList);
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const sendBugReport = createAsyncThunk(
    ACTION_TYPES.SEND_BUG_REPORT,
    async (
        {
            details,
            attachmentList
        }: { details: string; attachmentList: number[] },
        { rejectWithValue }
    ) => {
        try {
            return await sendBugReportApi(details, attachmentList);
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
